export default "__VITE_ASSET__Bm_KWtQz__"